import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { environment } from '@environments/environment';
import { authInterceptor } from '@interceptors/auth.interceptor';
import { NavigationService } from '@services/navigation.service';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      inject(NavigationService);
    }),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      }),
    ),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled' }), withPreloading(PreloadAllModules)),
  ],
};

const firebaseApp = initializeApp(environment.firebaseConfig);

export const auth = getAuth(firebaseApp);
auth.tenantId = environment.firebaseConfig.tenantId;

if (environment.local) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}
